module.exports = __webpack_public_path__ + "static/comsicon-f7724f38e53fb55e0d38fd1529ec7002.jpeg";